import { Component, Input, NgZone, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { EidosUser } from '@common/models/user-info.model';
import { EidosSecurityService } from '@common/services/eidos-security.service';
import { EidosBaseComponent } from '@common/components/eidos-base.component';
import { ModalRef } from '@app/core/services/core-modal.service';

@Component({
  selector: 'eidos-error-dialog',
  styleUrls: [
    'eidos-error-dialog.component.scss'
  ],
  templateUrl: 'eidos-error-dialog.component.html'
})
export class EidosErrorDialogComponent extends EidosBaseComponent implements OnInit {
  @Input() modalRef!: ModalRef;
  @Input() modalData!: Error;

  protected now: Date = new Date();
  protected userAgent: string = navigator.userAgent;
  protected url: string = window.location.pathname;
  protected user: EidosUser = new EidosUser();
  protected currentLoggedUserSubscription: Subject<any> = new Subject();

  get error(): Error {
    return this.modalData;
  }

  constructor(
    private eidosSecurityService: EidosSecurityService,
    private ngZone: NgZone,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.eidosSecurityService.currentLoggedUser.pipe(
      takeUntil(this.subscription)
    ).subscribe(user => {
      this.user = user;
    });

    if (this.modalData?.stack) {
      this.modalData.stack = this.modalData.stack.replace(/\n/g, "<br />");
    }

    if (this.modalData && !this.modalData.name) {
      this.modalData.name = 'ERROR';
    }
  }

  close(): void {
    this.ngZone.run(() => this.modalRef.close());
  }
}
